/**
 * Asynchronously loads the component for SignUpPage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const SignInPage = lazyLoad(
  () => import('./index'),
  module => module.SignInPage,
  {
    fallback: <LoadingIndicator />,
  },
);
